export const DataLoadingStatusEnum = {
  LOADING: 0,
  READY: 1,
};
